var map = {
	"./ico1.png": "yP2F",
	"./ico10.png": "SF0M",
	"./ico2.png": "xUyJ",
	"./ico3.png": "Fjcd",
	"./ico4.png": "O0y5",
	"./ico5.png": "61hT",
	"./ico6.png": "z+yZ",
	"./ico7.png": "0Hy8",
	"./ico8.png": "JRUd",
	"./ico9.png": "ML+s"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DYWS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/ico.*\.png$
// module id = DYWS
// module chunks = 1